import { render } from "./MaixMagicDashboard.vue?vue&type=template&id=33b9ca6e&scoped=true"
import script from "./MaixMagicDashboard.vue?vue&type=script&lang=js"
export * from "./MaixMagicDashboard.vue?vue&type=script&lang=js"

import "./MaixMagicDashboard.vue?vue&type=style&index=0&id=33b9ca6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b9ca6e"]])

export default __exports__